/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import RadioGroupComponent from '../../../SharedModules/RadioGroup/RadioGroupBtn';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import {
  RebateSummaryTableHead,
  RebateSummaryTableHead2,
} from './RebateSummaryTableHead';
import {
  dispatchErrorMsgRebateSummary,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchRebateProgramName,
  getRebateSummaryInvoiced,
  getRebateSummaryDispute,
  getRebateSummaryPayment,
  getStateFiscalYear,
  setRbtSummTblRec,
  setSearchScreenObjData,
} from './store/action';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';

import {
  STATUS_MSG,
  SUCCESS_MSG,
  REBATE_PROGRAM_REQUIRED,
} from '../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../SharedModules/Table/store/Actions';
import {
  handleScrollToEvent,
  removeCommaForNumberFiled,
} from '../../../SharedModules/CommonUtilities/commonUtilities';

const RebateSummary = () => {
  const dispatch = useDispatch();
  const {
    timePeriod: timePeriodValue,
    planTypeCD,
    rebateProgramCD,
    year,
  } = useSelector((state) => state?.sharedState?.RebateSummaryReducer);
  const searchScreenReduxData = useSelector(
    (state) => state?.sharedState?.RebateSummaryReducer?.searchScreenObj
  );
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [radioList, setRadioList] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [timePeriod, setTimePeriod] = React.useState(
    searchScreenReduxData?.timePeriod || ''
  );
  const [yearValue, setYearValue] = React.useState(
    searchScreenReduxData?.year || ''
  );
  const [filteredRows, setFilteredRow] = React.useState([]);

  const handleTimePeriodChange = (event) => {
    setTimePeriod(event.target.value);
    dispatch(setRbtSummTblRec([]));
    if (event.target.value === 'Quarter') {
      setYearValue('');
    } else {
      setYearValue('Calender');
    }
    dispatch(
      setSearchScreenObjData({
        ...searchScreenReduxData,
        timePeriod: event.target.value,
        year: event.target.value === 'Quarter' ? '' : 'Calender',
      })
    );
  };

  const handleYearChange = (event) => {
    setYearValue(event.target.value);
    dispatch(setRbtSummTblRec([]));
    dispatch(
      setSearchScreenObjData({
        ...searchScreenReduxData,
        year: event.target.value,
      })
    );
  };
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const planTypeList = useSelector(
    (state) => state?.sharedState?.RebateSummaryReducer?.planType
  );

  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.RebateSummaryReducer?.errorMsgRebateSummary
  );
  const rebateSummaryTblData = useSelector(
    (state) => state?.sharedState?.RebateSummaryReducer?.rebateSummaryTblData
  );
  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.RebateSummaryReducer?.performDisputeResolutionObj
  );

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const getRebateSummaryInvoicedList = useSelector(
    (state) => state?.sharedState?.RebateSummaryReducer?.rebateInvoiced
  );
  const getRebateSummaryDisputeList = useSelector(
    (state) => state?.sharedState?.RebateSummaryReducer?.rebateDispute
  );
  const getRebateSummaryPaymentList = useSelector(
    (state) => state?.sharedState?.RebateSummaryReducer?.rebatePayment
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  // const [rebateSummary, setRebateSummary] = React.useState([]);
  // const [rebateSummary1, setRebateSummary1] = React.useState([]);
  // const [isSearchClicked, setSearchClicked] = React.useState(false);

  // getRebateSummaryInvoice
  // const data1 = getRebateSummaryInvoicedList?.rebateDataGridReportVO ?? [];

  // const data2 = getRebateSummaryDisputeList?.rebateDisputeGridReportVO ?? [];

  // const data3 = getRebateSummaryPaymentList?.data ?? [];

  // const data = data1.reduce((acc, curr) => {
  //   const matchingObj1 = data2.find((obj) => obj.qtr === curr.qtr);
  //   const matchingObj2 = data3.find((obj) => obj.receiptQtr === curr.qtr);
  //   if (matchingObj1) {
  //     if (matchingObj2) {
  //       const mergedObj = Object.assign(curr, matchingObj1, matchingObj2);
  //       mergedObj.qtr = mergedObj.receiptQtr;
  //       delete mergedObj.receiptQtr;
  //       acc.push(mergedObj);
  //     } else {
  //       acc.push(Object.assign(curr, matchingObj1));
  //     }
  //   } else {
  //     acc.push(curr);
  //   }
  //   return acc;
  // }, []);

  // const newData = data.reverse();
  // const combinedData = {};

  // // Loop through the data and combine values for duplicate years
  // newData.forEach((item) => {
  //   if (combinedData[item.year]) {
  //     combinedData[item.year].totalAmount += item.totalAmount || 0;
  //     combinedData[item.year].invoiceNumCount += item.invoiceNumCount || 0;
  //     combinedData[item.year].sumOfAmount += item.sumOfAmount || 0;
  //     combinedData[item.year].totalReceivedAmt += item.totalReceivedAmt || 0;
  //     combinedData[item.year].numberOfChecks += item.numberOfChecks || 0;
  //     combinedData[item.year].labelerCode += item.labelerCode || 0;
  //   } else {
  //     combinedData[item.year] = { ...item };
  //   }
  // });

  // Convert the combined data object into an array
  // const combinedDataArray = Object.values(combinedData);
  // Function to round values to two decimal places
  // const roundToTwoDecimalPlaces = (value) => {
  //   return Math.round((value + Number.EPSILON) * 100) / 100;
  // };

  // Create a new array with rounded values
  // const roundedData = combinedDataArray.map((item) => ({
  //   ...item,
  //   totalAmount: roundToTwoDecimalPlaces(item.totalAmount),
  //   sumOfAmount: roundToTwoDecimalPlaces(item.sumOfAmount),
  //   totalReceivedAmt: roundToTwoDecimalPlaces(item.totalReceivedAmt),
  // }));
  // pinned row

  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : rebateSummaryTblData;

    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data).toFixed(2) : '0.00';
  };
  const sum2 = (property) => {
    const displayedRows = filterApply ? filteredRows : rebateSummaryTblData;
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator +
        (object[property]
          ? parseFloat(removeCommaForNumberFiled(object[property]))
          : 0)
      );
    }, 0);
    return data ? parseFloat(data) : 0;
  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        qtr: 'Total',
        year: 'Total',
        totalAmount: sum('totalAmount'),
        invoiceNumCount: sum2('invoiceNumCount'),
        totalReceivedAmt: sum('totalReceivedAmt'),
        numberOfChecks: sum2('numberOfChecks'),
        sumOfAmount: sum('sumOfAmount'),
        labelerCode: sum2('labelerCode'),
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rebateSummaryTblData, filteredRows, filterApply]);

  // states with initial values

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd:
            planTypeCD || userDefaults?.planTypeCd
              ? planTypeCD || userDefaults?.planTypeCd
              : 'FD',
          rebateProgramCd:
            rebateProgramCD || userDefaults?.rebateProgramCd
              ? rebateProgramCD || userDefaults?.rebateProgramCd
              : '-1',
        }
  );

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);

  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      // setShowTable(false);
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
    }
    if (name === 'rebateProgramCd') {
      // setShowTable(false);
      setState({ ...state, [name]: value });
    }
    dispatch(setRbtSummTblRec([]));
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRebateSummary(unique));
  };

  // on blur functionality on field levell
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRebateSummary(unique));
  };

  // React.useEffect(() => {
  //   const data = newData.map((item) => {
  //     return {
  //       ...item,
  //       totalReceivedAmt: item.totalReceivedAmt ? item.totalReceivedAmt : 0.0,
  //       numberOfChecks: item.numberOfChecks ? item.numberOfChecks : 0,
  //       sumOfAmount: item.sumOfAmount ? item.sumOfAmount : 0.0,
  //       labelerCode: item.labelerCode ? item.labelerCode : 0,
  //       invoiceNumCount: item.invoiceNumCount ? item.invoiceNumCount : 0,
  //       totalAmount: item.totalAmount ? item.totalAmount : 0.0,
  //     };
  //   });
  //   setRebateSummary(data);
  //   if (newData.length == 0) {
  //     setShowTable(false);
  //   } else {
  //     setShowTable(true);
  //   }
  // }, [
  //   getRebateSummaryInvoicedList,
  //   getRebateSummaryDisputeList,
  //   getRebateSummaryPaymentList,
  // ]);

  // React.useEffect(() => {
  //   const data = roundedData.map((item) => {
  //     return {
  //       ...item,
  //       totalReceivedAmt: item.totalReceivedAmt ? item.totalReceivedAmt : 0.0,
  //       numberOfChecks: item.numberOfChecks ? item.numberOfChecks : 0,
  //       sumOfAmount: item.sumOfAmount ? item.sumOfAmount : 0.0,
  //       labelerCode: item.labelerCode ? item.labelerCode : 0,
  //       invoiceNumCount: item.invoiceNumCount ? item.invoiceNumCount : 0,
  //       totalAmount: item.totalAmount ? item.totalAmount : 0.0,
  //     };
  //   });
  //   setRebateSummary1(data);
  //   if (newData.length == 0) {
  //     setShowTable(false);
  //   } else {
  //     setShowTable(true);
  //   }
  // }, [
  //   getRebateSummaryInvoicedList,
  //   getRebateSummaryDisputeList,
  //   getRebateSummaryPaymentList,
  // ]);
                
  // remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgRebateSummary([]));
  }, [ state.planTypeCd, planTypeList, state.rebateProgramCd, timePeriod, yearValue, fullScreenView ]);
  
  const handleSearchClick = async () => {
    dispatch(clearReduxForFilterAndSort('/rebatesummary'));
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    )?.name;
    const rpcShort = rebateProgramName?.split('|')[0]?.trim();
    let localErr = getErrorMsg || [];
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRebateSummary(unique));
    if (state.rebateProgramCd != '-1') {
      // setShowTable(true);
      dispatch(
        dispatchRebateProgramName({
          rebateProgramName,
          timePeriod,
          planTypeCD: state.planTypeCd,
          rebateProgramCD: state.rebateProgramCd,
          yearValue,
        })
      );

      const invoiced = await dispatch(
        getRebateSummaryInvoiced({
          rebateProgramCd: rpcShort,
          qtrOrYear: timePeriod == 'Quarter' ? 'Quarter' : yearValue,
        })
      );
      const invTblData = invoiced.rebateDataGridReportVO;
      const dispute = await dispatch(
        getRebateSummaryDispute({
          rebateProgramCd: rpcShort,
          qtrOrYear: timePeriod == 'Quarter' ? 'Quarter' : yearValue,
        })
      );
      const dispTblData = dispute.rebateDisputeGridReportVO;
      const payment = await dispatch(
        getRebateSummaryPayment({
          rebateProgramCd: rpcShort,
          qtrOrYear: timePeriod == 'Quarter' ? 'Quarter' : yearValue,
        })
      );
      const payTblData = payment.data.map((obj) => {
        obj.qtr = obj.receiptQtr;
        return obj;
      });
      let tbdata = invTblData.concat(
        dispTblData.filter(
          (item2) => !invTblData.some((item1) => item1.qtr === item2.qtr)
        )
      );
      tbdata = tbdata
        .concat(
          payTblData.filter(
            (item2) => !tbdata.some((item1) => item1.qtr === item2.qtr)
          )
        )
        .map((obj) => ({
          ...payTblData.find((o) => o.qtr === obj.qtr),
          ...invTblData.find((o) => o.qtr === obj.qtr),
          ...dispTblData.find((o) => o.qtr === obj.qtr),
        }))
        .map((item) => {
          return {
            year: item.year,
            qtr: item.qtr,
            totalReceivedAmt: item.totalReceivedAmt
              ? item.totalReceivedAmt
              : 0.0,
            numberOfChecks: item.numberOfChecks ? item.numberOfChecks : 0,
            sumOfAmount: item.sumOfAmount ? item.sumOfAmount : 0.0,
            labelerCode: item.labelerCode ? item.labelerCode : 0,
            invoiceNumCount: item.invoiceNumCount ? item.invoiceNumCount : 0,
            totalAmount: item.totalAmount ? item.totalAmount : 0.0,
          };
        });
      if (timePeriod === 'Year') {
        let startfrom = 1;
        if (yearValue === 'federal') {
          startfrom = 4;
        }
        if (yearValue === 'state') {
          startfrom = await getStateFiscalYear({
            rebateProgramCd: state?.rebateProgramCd,
          });
        }

        const yearList = [...new Set(tbdata.map((o) => o.year))];
        const newdt = [];
        yearList.map((o) => {
          let arr = [];
          if (startfrom == 1) {
            arr = [`1Q${o}`, `2Q${o}`, `3Q${o}`, `4Q${o}`];
          }
          if (startfrom == 2) {
            arr = [`1Q${parseFloat(o) + 1}`, `2Q${o}`, `3Q${o}`, `4Q${o}`];
          }
          if (startfrom == 3) {
            arr = [
              `1Q${o}`,
              `2Q${o}`,
              `3Q${parseFloat(o) - 1}`,
              `4Q${parseFloat(o) - 1}`,
            ];
          }
          if (startfrom == 4) {
            arr = [`1Q${o}`, `2Q${o}`, `3Q${o}`, `4Q${parseFloat(o) - 1}`];
          }
          const actualqtrs = tbdata?.filter((ob) => arr.indexOf(ob.qtr) !== -1);
          if (actualqtrs.length) {
            let totalReceivedAmt = 0;
            let numberOfChecks = 0;
            let sumOfAmount = 0;
            let labelerCode = 0;
            let invoiceNumCount = 0;
            let totalAmount = 0;
            for (let i = 0; i < actualqtrs.length; i += 1) {
              totalReceivedAmt += actualqtrs[i].totalReceivedAmt;
              numberOfChecks += actualqtrs[i].numberOfChecks;
              sumOfAmount += actualqtrs[i].sumOfAmount;
              labelerCode += actualqtrs[i].labelerCode;
              invoiceNumCount += actualqtrs[i].invoiceNumCount;
              totalAmount += actualqtrs[i].totalAmount;
            }
            newdt.push({
              year: o,
              qtr: null,
              totalReceivedAmt: totalReceivedAmt,
              numberOfChecks: numberOfChecks,
              sumOfAmount: sumOfAmount,
              labelerCode: labelerCode,
              invoiceNumCount: invoiceNumCount,
              totalAmount: totalAmount,
            });
          }
          return o;
        });
        tbdata = newdt;
      }
      dispatch(
        setRbtSummTblRec(
          tbdata?.length > 0 ? tbdata?.sort((a, b) => b.year - a.year) : []
        )
      );
    }
  };

  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };
  const firstInfo = '';
  const secondInfo = '';
  let thirdInfo = '';
  const fourthInfo = '';

  // TO get the complete name of the rebate program for PDF
  let rebateProgramNameValue =
    rebateProgramList.find(
      (item) => item.rebateProgramCd === state.rebateProgramCd
    ) || '';
  rebateProgramNameValue = `${rebateProgramNameValue?.rebateProgramCd} ${
    rebateProgramNameValue?.shortDescr || ''
  }`;

  thirdInfo = `${rebateProgramNameValue} by ${timePeriod}`;
  return (
    <div className="tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Summary Reports" parent2="Rebate Summary" />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          }
        />
      ) : null}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="filter-plantype-RebateSum"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  reqColor
                  defaultValue={state && state.planTypeCd}
                  filterAction={(e) => {
                    handleOnChangeEvent(e, 'planTypeCd');
                  }}
                />
              </div>
              <div className="col-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Rebate Program <span className="mandatory"> *</span>{' '}
                  </legend>
                  <div className="form-wrapper p-0">
                    <div className="mui-custom-form with-select field-xl no-lbl">
                      <TextField
                        name="rebateProgram"
                        id="rebateProgramSelect"
                        label="rebateProgramSelect"
                        data-testid="RebateSum-rebatePrg"
                        fullWidth
                        select
                        required
                        inputProps={{
                          maxLength: 11,
                          id: 'rebateProgramSelect',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={
                          getErrorMsg?.length > 0
                            ? _.map(getErrorMsg, (l) =>
                                l.field === 'rebateProgramCd'
                                  ? 'mandate-fields frr-display-hidden-label'
                                  : 'frr-display-hidden-label'
                              )
                            : 'frr-display-hidden-label'
                        }
                        onBlur={(e) =>
                          handleOnblurEvent('rebateProgramCd', e.target.value)
                        }
                        onChange={(e) =>
                          handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                        }
                        value={
                          state && state.rebateProgramCd
                            ? state.rebateProgramCd
                            : ''
                        }
                        error={
                          getErrorMsg?.length > 0
                            ? _.map(getErrorMsg, (l) =>
                                l.field === 'rebateProgramCd' ? l.message : null
                              )
                            : null
                        }
                        helperText={
                          getErrorMsg?.length > 0
                            ? _.map(getErrorMsg, (l) =>
                                l.field === 'rebateProgramCd' ? l.message : null
                              )
                            : null
                        }
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {rebateProgramList?.length > 0
                          ? rebateProgramList?.map((item) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Quarter <span className="mandatory"> *</span>{' '}
                  </legend>
                  <div className="row">
                    <div className="col-sm-12">
                      <FormControl>
                        <RadioGroup
                          row
                          name="QTR"
                          data-testid="RebateSum-QTR"
                          required
                          value={timePeriod}
                          onChange={handleTimePeriodChange}
                        >
                          <FormControlLabel
                            value="Quarter"
                            control={<Radio />}
                            label="Quarter"
                            data-test="Quarter"
                          />
                          <FormControlLabel
                            value="Year"
                            control={<Radio />}
                            label="Year"
                            data-test="Year"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                  <div className="col-sm-8">
                    <div
                      className="mui-custom-form with-select input-md override-width-95"
                      style={{ marginTop: '-14px' }}
                    >
                      <TextField
                        fullWidth
                        select
                        required
                        data-testid="RebateSum-year"
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={yearValue}
                        className="frr-display-hidden-label"
                        onChange={handleYearChange}
                        disabled={timePeriod === 'Quarter'}
                        name="calender"
                        id="calender"
                        label="calender"
                        InputProps={{ id: 'calender' }}
                        defaultValue="calender"
                      >
                        <MenuItem key="calendar" value="Calender">
                          Calendar
                        </MenuItem>
                        <MenuItem key="Federal Fiscal" value="federal">
                          Federal Fiscal
                        </MenuItem>
                        <MenuItem key="State Fiscal" value="state">
                          State Fiscal
                        </MenuItem>
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="btn-wrapper col-12">
        <Button
          data-testid="Rebate-Summary-btn"
          onClick={handleSearchClick}
          className="btn btn-success btn-search float-right"
        >
          <SVGComponent iconName="Icon-search" /> Search
        </Button>
      </div>
      <br />
      <br />
      <br />
      <div
        id="testGrid"
        className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
      >
        {rebateSummaryTblData?.length ? (
          <TableGrid
            gridHeight={fullScreenView ? '100vh' : 350}
            columnDefs={
              timePeriod == 'Quarter'
                ? RebateSummaryTableHead
                : RebateSummaryTableHead2
            }
            data-testid="rebate-summary-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            rowData={rebateSummaryTblData?.map((item) => {
              return {
                ...item,

                totalReceivedAmt:
                  parseFloat(item?.totalReceivedAmt) === 0
                    ? '0.00'
                    : parseFloat(item?.totalReceivedAmt)?.toFixed(2),

                totalAmount:
                  parseFloat(item?.totalAmount) === 0
                    ? '0.00'
                    : parseFloat(item?.totalAmount)?.toFixed(2),
                sumOfAmount:
                  parseFloat(item?.sumOfAmount) === 0
                    ? '0.00'
                    : parseFloat(item?.sumOfAmount)?.toFixed(2),
              };
            })}
            noGlobalSort
            exportFile
            animateRows
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            sideBar={false}
            fileName="RebateSummary"
            reportName="Rebate Summary Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onFilterData={onFilterChanged}
            onCellFocused={onCellFocused}
            handleFullScreenViewClick={changeFullScreenView}
            pinnedBottomRowData={pinnedBottomRowData}
            info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
            getFilterApply={getFilterApply}
          />
        ) : null}
        {/* {showTable && timePeriod == 'Year' && (
          <TableGrid
            gridHeight={fullScreenView ? '100vh' : 350}
            columnDefs={RebateSummaryTableHead2}
            data-testid="rebate-summary-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            rowData={rebateSummary1?.map((item) => {
              return {
                ...item,

                totalReceivedAmt:
                  item.totalReceivedAmt === 0
                    ? '0.00'
                    : item.totalReceivedAmt.toFixed(2),

                totalAmount:
                  item.totalAmount === 0 ? '0.00' : item.totalAmount.toFixed(2),
                sumOfAmount:
                  item.sumOfAmount === 0 ? '0.00' : item.sumOfAmount.toFixed(2),
              };
            })}
            exportFile
            animateRows
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            sideBar={false}
            fileName="RebateSummary"
            reportName="Rebate Summary Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onFilterData={onFilterChanged}
            onCellFocused={onCellFocused}
            handleFullScreenViewClick={changeFullScreenView}
            pinnedBottomRowData={pinnedBottomRowData}
            info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
            getFilterApply={getFilterApply}
          />
        )} */}
      </div>
    </div>
  );
};

export default RebateSummary;
